import ApiService from '@/common/api.service'

const getUserInfo = (email, password) => {
  return ApiService.post('/admin/login', {
    'email': email,
    'password': password
  })
}

const isFinished = email => {
  return ApiService.post('/admin/isFinished', {
    'email': email 
  })
}

export default {
  async login(email, password) {
    try {
      const getUserInfoPromise = await getUserInfo(email, password)
      //const isFinishedPromise = await isFinished(email) // Promise.all의 예시를 위해 집어넣음
      //const [userInfoResponse, isFinishedResponse] = await Promise.all([getUserInfoPromise, isFinishedPromise])
      const [userInfoResponse] = await Promise.all([getUserInfoPromise])
      //console.log('userinfo', userInfoResponse)
      //console.log('finished', isFinishedResponse)
      if (userInfoResponse.data.length === 0) return 'noAuth' // 로그인 결과에 따른 분기 처리를 해준다
      //if (isFinishedResponse.data[0].CNT > 0) return 'done'
      return userInfoResponse
    } catch (err) {
      console.error(err)
    }
  }
}



// WEBPACK FOOTER //
// ./src/service/loginAPI.js